import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import hasAccess from "../helpers/hasAccess";

export default function MenuItem(props) {
  const IconComponent = props.iconComponent;

  const isCurrentPage = (path) => {
    return props.location.pathname === path;
  };

  if (!props.access || (props.access && hasAccess(props.access))) {
    return (
      <ListItem
        button
        key={props.label}
        component="a"
        href={props.url}
        selected={isCurrentPage(props.url)}
      >
        <ListItemIcon>
          <IconComponent />
        </ListItemIcon>
        <ListItemText primary={props.label} />
      </ListItem>
    );
  }

  return null;
}
